import { Skeleton } from "@/components/ui/skeleton";

export function MilesProgramCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 w-full mx-auto">
      <div className="flex flex-col xl:flex-row items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="w-8 h-8 rounded" />
          <div>
            <Skeleton className="h-6 w-32 mb-2" />
            <Skeleton className="h-5 w-24 rounded-full" />
          </div>
        </div>
        <div className="text-right">
          <Skeleton className="h-8 w-24 mx-auto mb-1" />
          <Skeleton className="h-4 w-32 mx-auto" />
        </div>
      </div>

      <hr className="border-gray-200 mb-6" />

      {/* Miles For Sale */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-6 w-24 rounded-sm" />
        </div>

        <div className="px-3 mb-4">
          <Skeleton className="h-5 w-full mb-4" />
          <div className="flex justify-between text-xs text-gray-500">
            <Skeleton className="h-3 w-10" />
            <Skeleton className="h-3 w-10" />
            <Skeleton className="h-3 w-10" />
          </div>
        </div>
      </div>

      <hr className="border-gray-200 mb-6" />

      {/* Loyalty Status */}
      <div className="mb-8">
        <Skeleton className="h-12 w-full rounded-sm mb-2" />
        <Skeleton className="h-4 w-48 mt-2" />
      </div>

      {/* Pricing Breakdown */}
      <div className="space-y-4 bg-[#F9F9F9] rounded-sm p-4">
        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-6 w-20" />
        </div>

        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-6 w-20" />
        </div>

        <div className="flex justify-between items-center border-t pt-2">
          <Skeleton className="h-7 w-32" />
          <Skeleton className="h-7 w-24" />
        </div>
      </div>
    </div>
  );
}
